import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Clear stale pendingOrder that may cause flash on reload
try { sessionStorage.removeItem('pendingOrder'); } catch {}

// Global error handlers to diagnose crashes
window.addEventListener('error', (e) => {
  console.error('🔴 GLOBAL ERROR:', e.message, e.filename, e.lineno, e.colno);
  document.title = `ERROR: ${e.message}`;
  const el = document.getElementById('root');
  if (el && !el.dataset.errorShown) {
    el.dataset.errorShown = 'true';
    const div = document.createElement('div');
    div.style.cssText = 'background:#1a1a1a;color:#facc15;padding:2rem;font-family:monospace;min-height:100vh';
    div.innerHTML = `<h1 style="font-size:1.5rem;margin-bottom:1rem">Runtime Error</h1>
      <pre style="color:#ff6b6b;white-space:pre-wrap">${e.message}</pre>
      <pre style="color:#888;margin-top:0.5rem;font-size:0.75rem">${e.filename}:${e.lineno}:${e.colno}</pre>`;
    el.prepend(div);
  }
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('🔴 UNHANDLED PROMISE:', e.reason);
});

console.log('Keyiscreation v7.2 loading...');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);